import { AuthConfig } from 'angular-oauth2-oidc';
import { AppSettings } from 'src/settings/appsettings.interface';

export function getAuthConfig(settings: AppSettings): AuthConfig {
  const authConfig = settings.authConfig;

  return new AuthConfig({
    issuer: authConfig.issuer,
    clientId: authConfig.clientId,
    responseType: 'code',
    scope: 'openid profile email offline_access access_token:email',
    timeoutFactor: 0.75,
    useSilentRefresh: false,
    showDebugInformation: false,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    customQueryParams: {
      audience: authConfig?.audience ?? undefined,
    },
  });
}
